// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BLuuPsWzwyTvWgK6tw71{display:block !important}.CgAovnZBrFl1OMt4EYjN{cursor:not-allowed}`, "",{"version":3,"sources":["webpack://./../@depmap/selects/src/styles/SliceSelect.scss"],"names":[],"mappings":"AAAA,sBACE,wBAAA,CAGF,sBACE,kBAAA","sourcesContent":[".unblockable {\n  display: block !important;\n}\n\n.disabledOption {\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"unblockable": `BLuuPsWzwyTvWgK6tw71`,
	"disabledOption": `CgAovnZBrFl1OMt4EYjN`
};
export default ___CSS_LOADER_EXPORT___;
